<template>
    <div>
        <app-card
            headerIcon="report"
            heading="Nonconformance"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :fullBlock="true"
            refreshMethod="refreshNonconformances"
            :reload="reload"
        >
            <nonconformances></nonconformances>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" class="mr-2" color="primary" @click="$router.push({ name: 'nonconformance' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshNonconformances"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import Nonconformances from "App_components/Widgets/Nonconformance.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        Nonconformances,
    },
    props: {
        refreshMethod: {
            type: Function,
        },
    },
    data() {
        return {
            name: "nonconformance",
            reload: false,
        };
    },
    computed: {
        ...mapActions(["fetchQualityControl"]),
        ...mapState({
            dashboard_quality_control: (state) => state.quality_control.dashboard_quality_control,
        }),
    },
    methods: {
        async refreshNonconformances(refresh = false) {
            this.reload = true;
            if (refresh) {
                await this.$store.commit("commitNonconformance", {
                    property: "dashboard_nonconformances",
                    with: null,
                });
            }

            await this.$store.dispatch("fetchNonconformance", {
                url: "nonconformance",
                method: "get",
                stateProperty: "dashboard_nonconformances",
                dataProperty: "nonconformances",
                commit: true,
                body: {
                    page_size: 10,
                    page_num: 1,
                },
            });
            this.reload = false;
        },
    },
};
</script>
